import "./BasicInfoSection.css";

function BasicInfoSection({
  formData,
  updateField,
}) {
  return (
    <div className="bakery-form-section">

      <h3 className="section-title">
        Basic Information
      </h3>

      <div className="bakery-form-grid">

        <div className="form-group">
          <label>Product Name</label>

          <input
            type="text"
            placeholder="Enter product name"
            value={formData.productName}
            onChange={(e) =>
              updateField("productName", e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Category</label>

          <select
            value={formData.category}
            onChange={(e) =>
              updateField("category", e.target.value)
            }
          >
            <option value="Cakes">Cakes</option>
            <option value="Pastries">Pastries</option>
            <option value="Cupcakes">Cupcakes</option>
            <option value="Cookies">Cookies</option>
            <option value="Brownies">Brownies</option>
            <option value="Donuts">Donuts</option>
            <option value="Breads">Breads</option>
            <option value="Buns">Buns</option>
            <option value="Puffs">Puffs</option>
            <option value="Pizza Base">Pizza Base</option>
            <option value="Muffins">Muffins</option>
            <option value="Biscuits">Biscuits</option>
            <option value="Chocolates">Chocolates</option>
            <option value="Desserts">Desserts</option>
        </select>

        </div>

        <div className="form-group full-width">
          <label>Description</label>

          <textarea
            rows="5"
            placeholder="Write product description..."
            value={formData.description}
            onChange={(e) =>
              updateField("description", e.target.value)
            }
          />
        </div>

      </div>

    </div>
  );
}

export default BasicInfoSection;